/**
 * Portal lead-move endpoints. All token-scoped to the caller's company: the
 * backend never takes a company from the client. Offered only when the
 * company has the lead-move flag (see useCompanyFeatures).
 */
import type { BatchMoveDestination, BatchMoveLeadsResult, BatchMovePreview } from '@viq-admin/screens';
import { adminFetch } from './dataProvider';

export interface CompanyFeatures {
  leadMove: boolean;
  /** `companies.store_card_images`: company admins see stored card images on lead detail. */
  cardImages: boolean;
}

/** GET /v1/admin/company/features */
export function fetchCompanyFeatures(): Promise<CompanyFeatures> {
  return adminFetch<CompanyFeatures>('/v1/admin/company/features');
}

/** GET /v1/admin/conferences — the company's granted, non-archived conferences. */
export async function listMoveDestinations(): Promise<BatchMoveDestination[]> {
  const body = await adminFetch<{ conferences: BatchMoveDestination[] }>('/v1/admin/conferences');
  return body.conferences;
}

/** POST /v1/admin/leads/move/preview */
export function previewMove(leadIds: string[]): Promise<BatchMovePreview> {
  return adminFetch<BatchMovePreview>('/v1/admin/leads/move/preview', {
    method: 'POST',
    body: JSON.stringify({ leadIds }),
  });
}

/** POST /v1/admin/leads/move */
export function moveLeads(leadIds: string[], destinationConferenceId: string): Promise<BatchMoveLeadsResult> {
  return adminFetch<BatchMoveLeadsResult>('/v1/admin/leads/move', {
    method: 'POST',
    body: JSON.stringify({ leadIds, destinationConferenceId }),
  });
}
